import { render, staticRenderFns } from "./GhostUserAlert.vue?vue&type=template&id=0b4a3def&scoped=true&"
import script from "./GhostUserAlert.vue?vue&type=script&lang=js&"
export * from "./GhostUserAlert.vue?vue&type=script&lang=js&"
import style0 from "./GhostUserAlert.vue?vue&type=style&index=0&id=0b4a3def&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4a3def",
  null
  
)

export default component.exports